import { render, staticRenderFns } from "./BrowserStats.vue?vue&type=template&id=d1e99e5e&scoped=true&"
import script from "./BrowserStats.vue?vue&type=script&lang=js&"
export * from "./BrowserStats.vue?vue&type=script&lang=js&"
import style0 from "./BrowserStats.vue?vue&type=style&index=0&id=d1e99e5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e99e5e",
  null
  
)

export default component.exports